<script>
import PanelHeader from '@components/invoices/form/PanelHeader.vue'

export default {
  name: 'CollapsiblePanel',
  components: { PanelHeader },
  props: {
    title: {
      type: String,
      required: true
    },
    bodyClassName: String,
    bodyInnerClassName: String
  },
  data () {
    return {
      isOpen: true
    }
  },
  methods: {
    handleToggleButtonClick () {
      this.isOpen = !this.isOpen
    }
  }
}
</script>

<template>
  <fragment>
    <PanelHeader
      :title="title"
      :isOpen="isOpen"
      :onToggleButtonClick="handleToggleButtonClick"
    >
      <slot name="head-end"></slot>
    </PanelHeader>

    <b-collapse v-model="isOpen" :class="bodyClassName">
      <b-card-body :class="bodyInnerClassName">
        <slot></slot>
      </b-card-body>
    </b-collapse>
  </fragment>
</template>

<style scoped lang="scss">

</style>
